import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { convertBytesToString } from 'helpers/convertBytesToString'

import { TProductFile, TProductParams } from '../../type'

// приведение данных о картинках к нужному типу

export function initProductImages(
  productId: number,
  productParams: TProductParams[],
  productFiles: TProductFile[],
): orderFormSpace.Images[][] {
  const imagesMap: Record<number, orderFormSpace.Images[]> = {}

  const imagesParams = productParams.filter(
    param => param.typeCode === 'IMAGES',
  )

  imagesParams.forEach(imageParam => {
    const matchingFile = productFiles.find(
      file => file.uid === imageParam.parameterValue.value,
    )

    if (matchingFile) {
      const image: orderFormSpace.Images = {
        id: matchingFile.uid,
        productId,
        paramId: imageParam.id,
        name: matchingFile.filename,
        serverUid: String(imageParam.parameterValue.value),
        previewUrl: matchingFile.url,
        size: convertBytesToString(matchingFile.size),
      }

      if (!imagesMap[imageParam.id]) {
        imagesMap[imageParam.id] = []
      }

      imagesMap[imageParam.id].push(image)
    }
  })

  return Object.values(imagesMap)
}
